import { render, staticRenderFns } from "./UltravioletRaysPopup.vue?vue&type=template&id=39da1cb0&scoped=true"
import script from "./UltravioletRaysPopup.vue?vue&type=script&lang=js"
export * from "./UltravioletRaysPopup.vue?vue&type=script&lang=js"
import style0 from "./UltravioletRaysPopup.vue?vue&type=style&index=0&id=39da1cb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da1cb0",
  null
  
)

export default component.exports